exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section {\n  background-color: white;\n  border: solid 1px lightgray;\n  border-radius: 10px;\n  padding: 10px;\n  margin: 10px; }\n\n.title {\n  padding-left: 0.5em;\n  padding-bottom: 0.5em;\n  margin-top: 0;\n  font-weight: bold; }\n\n.numeric-values {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: (1fr)[2];\n      grid-template-columns: repeat(2, 1fr);\n  grid-gap: 0.1em; }\n\n.numeric-value {\n  text-align: center;\n  background-color: #fff; }\n\n.left-align {\n  padding-left: 0.5em;\n  text-align: left; }\n\n.right-align {\n  padding-right: 0.5em;\n  text-align: right; }\n\n.value {\n  font-size: 1.3em;\n  font-weight: bold; }\n\n.label {\n  font-size: 12px;\n  color: gray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/kpi-rectangle/kpi-rectangle.component.scss
// module id = ../../../../../src/app/pages/dashboard/kpi-rectangle/kpi-rectangle.component.scss
// module chunks = main